<h1 [translateParams]="{
        vaultName: context.data.name
    }"
    translate
    matDialogTitle>
    credential_stores_confirm_delete_store_name
</h1>

<mat-dialog-content>
    <p [translateParams]="{
        robotCount: context.additionalData.robotCount,
        assetCount: context.additionalData.assetCount
    }"
       translate>credential_stores_confirm_delete_counts</p>

    <mat-tab-group class="tab-header"
                   dynamicHeight="true">
        <mat-tab #assetsTab
                 [label]="'credential_store_delete_modal_assets_tab' | translate">
        </mat-tab>
        <mat-tab #robotsTab
                 [label]="'credential_store_delete_modal_robots_tab' | translate">
        </mat-tab>
    </mat-tab-group>

    <ui-asset-credential-store-resources-grid #assetCredentialStoreResourcesGridLoading
                                               [hidden]="!assetsTab.isActive">
    </ui-asset-credential-store-resources-grid>

    <ui-robot-credential-store-resources-grid #robotCredentialStoreResourcesGridLoading
                                              [hidden]="!robotsTab.isActive">
    </ui-robot-credential-store-resources-grid>

    <mat-dialog-actions *ngLet="{
                            loading: (assetCredentialStoreResourcesGridLoading.loading$ | async)
                                || (robotCredentialStoreResourcesGridLoading.loading$ | async)
                        } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading"
                (click)="onConfirm()"
                ui-spinner-button
                mat-flat-button
                type="button"
                color="warn">
            {{ 'modal_action_delete' | translate }}
        </button>
    </mat-dialog-actions>
</mat-dialog-content>
